import React, { useEffect } from 'react';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import styles from './styles.module.scss';
import { BasicDropDown } from '@components-clean/core/basic-dropdown';
import { useCountrySelectorContext } from '@contexts-clean/country-selector-context';
import { usePageToolbar } from '@contexts-clean/page-toolbar-context';

const CountrySelector = () => {
    const { country, setCountry, countryList, isLoading } = useCountrySelectorContext();
    const { dispatch } = usePageToolbar();

    useEffect(() => {
        let route = location.pathname;
        const queryParams = new URLSearchParams(location.search);

        if (country?.value) queryParams.set('country', country.value);
        else queryParams.delete('country');

        if (queryParams.size) route = `${location.pathname}?${queryParams.toString()}`;

        dispatch({ type: 'setPopoutRoute', popoutRoute: route });
        // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
        // eslint-disable-next-line @eslint-react/exhaustive-deps
    }, [country]);

    const onChange = (value: DropDownListChangeEvent) => {
        setCountry(value.value);
    };

    return (
        <div className="k-d-flex k-align-items-center">
            <BasicDropDown
                data-testid="country-selector"
                data={countryList ?? []}
                type="card-header"
                className={styles.countrySelector}
                filterable
                customClassName="basic-dropdown-styling"
                cardHeader
                loading={isLoading}
                value={country}
                onChange={onChange}
                valueRender={(element, value) => {
                    const text = <span>{value.text}</span>;
                    // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
                    // eslint-disable-next-line @eslint-react/no-clone-element
                    return React.cloneElement(element, { ...element.props, title: undefined }, text);
                }}
                textField="text"
                dataItemKey="value"
            />
        </div>
    );
};

export default CountrySelector;
